module.exports = __webpack_public_path__ + "media/images/layers-416d9136.png";